import { CardRowDetail, CardRowDetailColumn, CardRowDetailLine, CardRowDetailLineSpacer } from "widgets";

import type { MainThreadHoverMessage } from "../../../types.ts";

export const TrackRegionTooltip = ({ data }: { data: Partial<MainThreadHoverMessage> }) => {
  return (
    <CardRowDetail>
      <CardRowDetailColumn>
        <CardRowDetailLine title="Name">{data.name}</CardRowDetailLine>
        <CardRowDetailLineSpacer />
        <CardRowDetailLine title="Region">
          {!!data.start &&
            !!data.stop &&
            `${data.start.toLocaleString("en-US")} — ${data.stop.toLocaleString("en-US")}`}
        </CardRowDetailLine>
        <CardRowDetailLine title="Length">
          {!!data.start && !!data.stop && `${(data.stop - data.start + 1).toLocaleString("en-US")} bp`}
        </CardRowDetailLine>
        <CardRowDetailLine title="Strand">{data.strand}</CardRowDetailLine>
      </CardRowDetailColumn>
    </CardRowDetail>
  );
};
